import PropTypes from 'prop-types';
import { Link, useSearchParams } from 'react-router-dom';

import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Filter from '@zenbusiness/zui/Filter';
import Skeleton from '@zenbusiness/zui/Skeleton';

import { DEFAULT_CATEGORY_FILTER, PRODUCTS_FILTER_PARAM_KEY } from '#client/pages/Home/ProductCards/constants';

function ProductCardsFilter({ items, loading }) {
  const [searchParams] = useSearchParams();
  const categoryFilter = searchParams.get(PRODUCTS_FILTER_PARAM_KEY) || DEFAULT_CATEGORY_FILTER;

  const handleFilterClickTracking = useLinkPressedCallback({
    elementName: 'category_filter'
  });

  if (loading) {
    return <Skeleton height={64} />;
  }

  return (
    <Filter
      onChange={handleFilterClickTracking}
      value={categoryFilter}
    >
      {items.map(({ label, state }) => (
        <Filter.Item
          component={Link}
          key={state}
          label={label}
          to={`?${PRODUCTS_FILTER_PARAM_KEY}=${state}`}
          value={state}
        />
      ))}
    </Filter>
  );
}

ProductCardsFilter.propTypes = {
  loading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      state: PropTypes.string
    })
  ).isRequired
};

export default ProductCardsFilter;
